<template lang="pug">
  v-row(no-gutters)
    // Left Column Skeleton - Invoice Details
    v-col.text-neutral-700(cols="9")
      yz-skeleton-loader(type="heading" class="mb-2")
      yz-skeleton-loader(type="text" class="mb-6")

      // Invoice details card skeleton
      yz-card.mt-6.pa-4(outlined)
        v-row(no-gutters)
          v-col(cols="4")
            yz-skeleton-loader(type="list-item-two-line")
          v-col(cols="4")
            yz-skeleton-loader(type="list-item-two-line")
          v-col(cols="4")
            yz-skeleton-loader(type="list-item-two-line")

      // Treatment items table skeleton
      yz-card.mt-6.px-4.py-3(outlined)
        yz-skeleton-loader(type="heading" class="mb-4")
        yz-skeleton-loader(type="table-thead")
        yz-skeleton-loader(type="table-tbody")

    // Divider Column
    yz-divider.mx-6(vertical)

    // Right Column Skeleton - Panel Claim Details
    v-col.text-neutral-700
      yz-skeleton-loader(type="heading" class="mb-2")
      yz-skeleton-loader(type="text" class="mb-6")

      // Panel summary card skeleton
      yz-card.mt-6.pa-3(outlined)
        yz-skeleton-loader(type="list-item-three-line")

      // Form fields skeleton
      .mt-6
        yz-skeleton-loader(type="text" class="mb-2")
        yz-skeleton-loader(type="text" class="mb-4")
        yz-skeleton-loader(type="text" class="mb-2")
        yz-skeleton-loader(type="text" class="mb-4")
        yz-skeleton-loader(type="text" class="mb-2")
        yz-skeleton-loader(type="paragraph")
</template>

<script>
export default {}
</script>